<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <!-- <h3><a href="#" data-bs-toggle="modal" data-bs-target="#myModalAddService"><i class="fa fa-plus-square"></i></a>&nbsp;Services <span class="badge bgbadge">{{services?.length}}</span> </h3> -->
                            <h3>
                                <div class="dropdown d-inline">
                                    <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fa fa-plus-square"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#myModalAddService">
                                                <i class="fa fa-plus-square"></i> Ajouter Service
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#myModalAddTypeService">
                                                <i class="fa fa-plus-square"></i> Ajouter Type Service
                                            </a>
                                        </li>
                                    </ul>
                                    &nbsp;Services 
                                    <span class="badge bg-secondary ms-auto me-3 font-medium px-2 py-1">{{ services?.length }}</span>
                                </div>
                            </h3>

                            <div class="table-responsive">
                                <template v-if="services?.length>0">  
                                    <table class="table table-striped table-bordered display text-center">
                                        <thead>
                                            <tr>
                                                <th>Service</th>
                                                <th>Prix de base</th>
                                                 <th>Description</th>
                                                <!--<th>Mail</th>
                                                <th>Site</th> -->
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="service in services" :key="service.id">
                                                    <td>
                                                        {{service.service}} &nbsp;
                                                        <a href="#" data-bs-toggle="modal" :data-bs-target="'#modalSpecialites' + service.id">
                                                            <i class="fa-solid fa-circle-info" style="color: #00C853 !important;" title="Voir les spécialités"></i>
                                                        </a>

                                                    </td>
                                                    <td>{{service.prix}} Gdes</td>
                                                    <td>{{service.description}}</td>
                                                    <td>
                                                        <!-- <a href="#" class="text-inverse mx-3" @click="getInfoPatient(service.id)"  title="Details" data-bs-toggle="modal" data-bs-target="#voirdetails"><i class="fa fa-eye "></i></a>&nbsp;&nbsp; -->
                                                        <a href="#" class="text-inverse mx-3" @click="editServ(service.id)" title="Edit" data-bs-toggle="modal" data-bs-target="#myModalUpdateService"><i class="fa fa-edit"></i></a>
                                                    </td>

                                                    <!-- 💡 La modale associée à ce service -->
                                                    <div class="modal fade" :id="'modalSpecialites' + service.id" tabindex="-1" aria-hidden="true">
                                                        <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                            <h5 class="modal-title">Service : {{ service.service }}</h5>
                                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                                                            </div>
                                                            <div class="modal-body">
                                                            <table class="table table-sm" v-if="service.specialites.length>0">
                                                                <thead>
                                                                <tr>
                                                                    <th>Spécialité</th>
                                                                    <th>Prix</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="spec in service.specialites" :key="spec.id">
                                                                    <td>{{ spec.specialite }}</td>
                                                                    <td>{{ spec.prix }} Gdes</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                            <p v-else>
                                                                Aucune spécialité
                                                            </p>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
        <!--Begin All Modal -->
          <!--Begin Add Service -->
          <div class="modal" id="myModalAddService">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Enrégister Service</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                        <div class="row" v-if="validationErrors.length>0">
                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                </ul>
                            </div>
                        </div>
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <div class=" mx-auto">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div>
                                        <label>
                                            <input type="checkbox" :value="saveDeja" v-model="saveDeja">
                                            Service Déja enrégistré
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group" v-if="!saveDeja">
                                            <label for="usname">Service</label>
                                            <input type="text" title="Ajouter Nom" placeholder="Nom" v-model="form.service" id="usname" class="form-control" autofocus="true">
                                        </div>
                                        <div class="form-group" v-if="saveDeja">
                                            <label for="usname">Service</label>
                                                <select class="form-control custom-select text-center" id="service" v-model="form.serviceId">
                                                    <option value="">--Services--</option>
                                                    <template v-if="services.length > 0">
                                                    <option v-for="(service,key) in services" :key="key" :value="service.id">{{ service.service }}</option>
                                                    </template>
                                                    <template v-else>
                                                    <option value="">Aucun Service trouvé</option>
                                                    </template>
                                                </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Prix</label>
                                            <input type="number" v-model="form.prix" title="Ajouter prix" placeholder="Prix" id="usadresse" class="form-control" required>
                                        </div>
                                    </div>                                    
                                </div> 
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Specialités</label>
                                            <select class="form-control text-center"  required v-model="form.specialite">
                                                <option value="">--Spécialité--</option>
                                                <template v-if="specialites.length > 0">
                                                <option v-for="(specialite,key) in specialites" :key="key" :value="specialite.id">{{specialite.specialite }}</option>
                                                </template>
                                                <template v-else>
                                                <option value="">Aucune Spécialité</option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Docteurs</label>
                                            <select class="form-control custom-select text-center" id="commune_patient" v-model="form.docteur">
                                                <option value="">--Docteurs--</option>
                                                <template v-if="docteurs.length > 0">
                                                <option v-for="(docteur,key) in docteurs" :key="key" :value="docteur.id">{{ docteur.nom }} {{ docteur.prenom }}</option>
                                                </template>
                                                <template v-else>
                                                <option value="">Aucun Docteur trouvé</option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div> 
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Description</label>
                                            <textarea name="" id="" class="form-control" required v-model="form.description"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="usname">Type Service</label>
                                            <select class="form-control custom-select text-center" id="commune_patient" v-model="form.tservice">
                                                <option value="">--Type--</option>
                                                <template v-if="typeServices.length > 0">
                                                <option v-for="(tservice,key) in typeServices" :key="key" :value="tservice.id">{{ tservice.nom_type }}</option>
                                                </template>
                                                <template v-else>
                                                <option value="">Aucun Type service trouvé</option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div>                                
                                <div class="row">
                                    <div class="pt-2">
                                        <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;" @click="registerService">Ajouter</button>
                                    </div>
                                </div>	
                        </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" id="closeModalAddAssurance" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
         </div>
          <!--End Add Service -->

          <!-- The Modal Update Service-->
            <div class="modal" id="myModalUpdateService">
                <div class="modal-dialog">
                    <div class="modal-content">             
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modifié Service</h5>
                            <button type="button" id="closeModifierUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                            <template v-if="editService?.id">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <!-- <form @submit.prevent="UpdateService"> -->
                                                <div class="row" v-if="validationErrors.length>0">
                                                    <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                        <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                            <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Service</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.service" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Prix</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <input type="text" v-model="form_update.prix" class="form-control">
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <p class="mb-0">Description</p>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <textarea v-model="form_update.description" class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            <!-- </form>    -->
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <!-- <p class="text-center">Loading...</p> -->
                                <div class="modal-preloader">
                                    <div class="spinner"></div>
                                </div>
                            </template>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer d-flex justify-content-between">
                            <button type="button" :disabled="form_update.service =='' || form_update.description=='' || form_update.prix=='' || form_update.id==''" class="btn float-left" style="background-color: #00C853; color: #fff;" @click="UpdateService">Enrégistrer</button>
                            <button type="button" id="closeModalUpdated" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        <!-- End Modal Update Service -->

        <!-- Start Modal add type service -->
        <div class="modal" id="myModalAddTypeService">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Enrégister Type Service</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                        <div class="row" v-if="validationErrors.length>0">
                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                </ul>
                            </div>
                        </div>
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <div class="container d-flex justify-content-center">
                            <div class="text-center" style="max-width: 600px; width: 100%;">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="usname" class="form-label fw-bold">Type Service</label>
                                            <input type="text" v-model="formType.nom" title="Ajouter Nom" placeholder="Nom" required id="usname" class="form-control" autofocus="true">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="descriptionType" class="form-label fw-bold">Description</label>
                                            <textarea rows="3" id="descriptionType" class="form-control" v-model="formType.description" required></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row text-center mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="btn btn-block btn-lg col-6" style="background:#00C853; color: #fff;" @click="registerTypeService">Ajouter</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" id="closeModalAddSpecialite" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
         </div>
         <!-- End Modal add type service -->

        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"ServiceAll",
    components:{
        DashView
    },
    data(){
      return{
          services:[],
          typeServices:[],
          saveDeja:false,
          specialites:[],
          selectedSpecialite:'',
          docteurs:[],
          editService:[],
          info_assurance:[],
          success_msg:'',
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          form:{
            service:'',
            serviceId:'',
            prix:'',
            description:'',
            specialite:'',
            docteur:'',
            tservice:''
          },
          form_update:{
            id:'',
            service:'',
            prix:'',
            description:''
          },
          formType:{
            nom:'',
            description:''
          }
      }
    },
    created(){
        axios.get(`${base_url}/services`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  console.log(response.data);
                  if(response?.data?.services){
                      this.services = response.data.services;
                  }                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year} à ${hours}h ${minutes}mn ${seconds}s`;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        registerService(){
            this.success_msg='';
            // const control = !!(this.form.service && this.form.description && this.form.prix);
            // if(control){
                    const $data ={
                        service : this.saveDeja ? this.form.serviceId : this.form.service,
                        prix : this.form.prix,
                        description : this.form.description,
                        specialite_id : this.form.specialite,
                        docteur_id:this.form.docteur,
                        already:this.saveDeja,
                        typ_service: this.form.tservice
                    };
                // console.log($data);
                // return false;
                axios.post(`${base_url}/add_service`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Service ajouté avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            // }
        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        editServ(id){
            this.editService = [];
            if(id){
                this.editService= this.services.filter((element)=>element.id==id)[0];
                this.form_update.id = this.editService.id;
                this.form_update.service = this.editService.service;
                this.form_update.prix = this.editService.prix;
                this.form_update.description = this.editService.description;
            }
        },
        UpdateService(){
            const $data={
                serviceId:this.form_update.id,
                service:this.form_update.service,
                prix:this.form_update.prix,
                description : this.form_update.description
            };
            // console.log($data);
            // return false;
            
            if($data){
                axios.put(`${base_url}/update_service`,$data,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response?.data);
                    if(response?.status==200){
                        setTimeout(function() {
                            location.reload();
                        },1);
                    }                
                })
                .catch((error)=>{
                    // console.log(error);
                        if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            this.displayValidationErrors(error.response.data.errors);                       
                        } 
                        else if(error?.response?.status === 403){
                            // this.$router.push('/no-access');
                            console.log('NO access');
                            $('#closeModalUpdateService').trigger('click');
                            $('#openModalButton').trigger('click');
                        }
                        else {
                        // Gérer d'autres erreurs ici
                        console.log('Autre erreur:', error);
                        }
                });
            }
        },
        getSpecialites(){
            axios.get(`${base_url}/specialites`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response?.data);
                    if(response?.status==200){
                        // console.log(response?.data);
                        if(response?.data?.length>0){

                            this.specialites = response.data;
                        }
                        // console.log(this.roles);
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
        },
        getDoctors(){
                axios.get(`${base_url}/getDoctors?specialite=${this.form.specialite}`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('Doctor');
                        
                        console.log(response?.data);
                        if(response?.status==200){
                            // console.log(response?.data);
                            if(response?.data?.docteurs.length>0){
                                this.docteurs = response?.data?.docteurs;
                            }
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
        },
        formatSpecialites(specialites) {
            if (!specialites || specialites.length === 0) {
            return "Aucune spécialité liée.";
            }
            return specialites.map(s => `${s.specialite} (${s.prix} Gdes)`).join(', ');
        },
        registerTypeService(){
            this.success_msg='';
            // const control = !!(this.form.service && this.form.description && this.form.prix);
            // if(control){
                    const $data ={
                        nom_service : this.formType.nom,
                        description:this.formType.description
                    };
                    console.log('Data');
                    
                console.log($data);
                // return false;
                axios.post(`${base_url}/add_service_type`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Type Service ajouté avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddAssurance').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            // }
        
        },
        getTypeServices(){
            axios.get(`${base_url}/get_type_services`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log('Type Services');                        
                        console.log(response?.data);
                        if(response?.status==200){
                            this.typeServices = response.data.typeServices;
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
        }

    },
    mounted(){
        this.getSpecialites();
        this.getDoctors();
        this.getTypeServices();
    },
}
</script>
<style scoped>
    .hrdivider {
  position: relative;
  margin-bottom: 20px;
  width: 80%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.hrdivider hr {
  border: none;
  border-top: 3px solid #0080ff;
  margin: 0;
}

.hrdivider span {
  position: absolute;
  top: -11px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  font-size: 15px;
}
.dropdown-toggle::after {
  display: none;
}
</style>